var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDislike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill-rule:evenodd;fill:url(#D\xE9grad\xE9_sans_nom_3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_3",
    y1: 32,
    x2: 64,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8452a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5b5ca8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56,40H48.5A1.5,1.5,0,0,0,47,41.5a1.32,1.32,0,0,0,.1.53h0a15.65,15.65,0,0,1,.9,5v9a8,8,0,0,1-16,0,14,14,0,0,0-2.65-7.77A2,2,0,0,1,29,47.05a2,2,0,0,1,3.62-1.3h0c2,2.53,3.41,5,3.41,7.26v3a4,4,0,0,0,8,0V48a11.86,11.86,0,0,0-.72-4.09A6,6,0,0,1,49,36h5a6,6,0,0,0,6-6V16A12,12,0,0,0,48,4H37.75c-5.5,0-10.21,5.49-16.23,7.36A3,3,0,0,0,20,13.94V35a5,5,0,0,1-1.27,3.3A5.05,5.05,0,0,1,18,39h0a5.28,5.28,0,0,1-.82.5l-.09,0a4.52,4.52,0,0,1-.83.29l-.17.05A4.66,4.66,0,0,1,15,40H8a8,8,0,0,1-8-8V12A8,8,0,0,1,8,4h2a2,2,0,0,1,0,4H8a4,4,0,0,0-4,4V32a4,4,0,0,0,4,4h6a2,2,0,0,0,2-2V13.41A6.47,6.47,0,0,1,19.84,7.5C25.93,5.78,30.35,0,37.88,0H48A16,16,0,0,1,64,15.18,7.38,7.38,0,0,1,64,16V32a8,8,0,0,1-8,8ZM26,40a2,2,0,1,1-2,2,2,2,0,0,1,2-2Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike);
export default __webpack_public_path__ + "static/media/dislike.a80ef34f9e799fcd7ce373e89bb47734.svg";
export { ForwardRef as ReactComponent };